<template>
  <div
    class="hidden tablet-h:flex h-[39px] items-center justify-end pl-5 pr-6"
    :class="componentClasses"
  >
    <template v-if="isFile">
      <div
        v-tooltip="'Selling coming soon'"
        class="w-[30px] h-[30px] flex items-center justify-center rounded-sm cursor-default mr-3 last:mr-0 opacity-50"
        :class="iconContainerClass"
      >
        <Icon
          :size="18"
          name="Coin"
          class="stroke-gray-800 pointer-events-none"
        />
      </div>

      <div
        v-tooltip="'Licensing coming soon'"
        class="w-[30px] h-[30px] flex items-center justify-center rounded-sm cursor-default mr-3 last:mr-0 opacity-50"
        :class="iconContainerClass"
      >
        <Icon
          :size="18"
          name="License"
          class="stroke-gray-800 pointer-events-none"
        />
      </div>

      <div
        v-tooltip="'View Dacr Certificate'"
        class="w-[30px] h-[30px] flex items-center justify-center rounded-sm cursor-pointer mr-3 last:mr-0"
        :class="iconContainerClass"
        @click="handleCertificateClick"
      >
        <Icon
          :size="18"
          name="Dacr"
          class="fill-gray-800 pointer-events-none"
        />
      </div>

      <div
        v-tooltip="'Share'"
        class="w-[30px] h-[30px] flex items-center justify-center rounded-sm cursor-pointer mr-3 last:mr-0"
        :class="iconContainerClass"
        @click="handleShareClick"
      >
        <Icon
          :size="18"
          name="Share"
          class="stroke-gray-800 pointer-events-none"
        />
      </div>
    </template>

    <div
      v-tooltip="'More'"
      class="w-[30px] h-[30px] flex items-center justify-center rounded-sm cursor-pointer mr-3 last:mr-0"
      :class="iconContainerClass"
      @click="handleToggle"
    >
      <Icon
        :size="18"
        name="ThreeDots"
        class="fill-gray-800 stroke-gray-800 pointer-events-none"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Item } from '@/shared/graphql/router/graphql'
import { isFile } from '@/features/explorer/utils/itemGuards'
import { computed } from 'vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { Dialogs } from '@/shared/dialogs/types'
import { Icon } from '@dacr/ui'

const props = defineProps<{
  isFile: boolean
  item: Item
  selected?: boolean
}>()
const emit = defineEmits<{
  contextMenuToggled: [event: MouseEvent]
}>()

const { open } = useDialog()

const file = computed(() => (isFile(props.item) ? props.item : null))

const componentClasses = computed(() => ({
  default: !props.selected,
  active: props.selected,
}))

const iconContainerClass = computed(() => ({
  'hover:bg-green-700/15': props.selected,
  'hover:bg-gray-800/8': !props.selected,
}))

const handleToggle = (event: MouseEvent) => {
  emit('contextMenuToggled', event)
}

const handleCertificateClick = () => {
  const certUrl = file.value?.copyright?.registrations[0]?.certificateUrl
  if (certUrl) {
    window.open(certUrl, '_blank')
  }
}

const handleShareClick = () => {
  open(Dialogs.Share, {
    props: { file: file.value },
  })
}
</script>

<style scoped>
.default {
  background: linear-gradient(to left, #f8f8f8 85%, transparent);
}

.active {
  background: linear-gradient(to left, rgb(236, 247, 248) 85%, transparent);
}
</style>
